import sileo from 'sileo';

/*
 * Workforce-Board related models
 **/

const WorkforceBoardCards = new sileo.Model('board', 'workforce-board-display-card');
const WorkforceBoardVisibility = new sileo.Model('board', 'workforce-board-visibility');
const WorkforceBoardCardDetails = new sileo.Model('board', 'workforce-board-card-details');

const state = {
    selectedIssuers: [],
    selectedExcludeIssuers: [],
    selectedSorter: 'newest',
};

const mutations = {
    setSelectedIssuers(state, data) {
        state.selectedIssuers = data;
    },
    setSelectedExcludeIssuers(state, data) {
        state.selectedExcludeIssuers = data;
    },
    setSelectedSorter(state, data) {
        state.selectedSorter = data;
    },
};

const actions = {
    fetchWorkforceBoardCards(context, filters) {
        return WorkforceBoardCards.objects.filter(filters);
    },

    async updateWorkforceBoardVisibility(context, data) {
        const form = new FormData();
        let pk = data.pk;

        for (let field in data) {
            form.append(field, data[field]);
        }

        return WorkforceBoardVisibility.objects.update({ 'pk': pk }, form);
    },

    getWorkforceBoardCardDetails(context, pk) {
        return WorkforceBoardCardDetails.objects.get(pk);
    },

    getColumnCard(_, cardId) {
        return WorkforceBoardCards.objects.get(cardId);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
